import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export const FEE_CHANNELS = ['airbnb_official', 'home_away'];

export default class PropertyFeeModel extends Model {
  @attr('number', { defaultValue: 0 }) perBookingPercentageTax!: number;
  @attr('number', { defaultValue: 0 }) perBookingAmountTax!: number;
  @attr('number', { defaultValue: 0 }) perPersonPerNightTax!: number;
  @attr('number', { defaultValue: 0 }) perNightTax!: number;
  @attr('number', { defaultValue: 0 }) cleaningFee!: number;
  @attr('number') monthlyDiscount!: number;
  @attr('number') weeklyDiscount!: number;
  @attr('number') airbnbManagementFeeFlatAmount!: number | null;
  @attr('number') airbnbManagementFeePercentageAmount!: number | null;
  @attr('number') resortFeeFlatAmount!: number | null;
  @attr('number') resortFeePercentageAmount!: number | null;
  @attr('number') communityFeeFlatAmount!: number | null;
  @attr('number') communityFeePercentageAmount!: number | null;
  @attr('number') linenFeeFlatAmount!: number;
  @attr('number') offlineSecurityDepositFlatAmount!: number;
  @attr('boolean', { defaultValue: false })
  offlineSecurityDepositFollowsDeposit!: boolean;
  @attr('number') petFeeFlatAmount!: number;
  @attr('number') visitorLevyFlatAmount!: number | null;
  @attr('number') visitorLevyPercentageAmount!: number | null;
  @attr('boolean', { defaultValue: false }) visitorLevyCollectLocally!: boolean;
  @attr('number') visitorLevyMaxNights!: number | null;

  @attr('array', { defaultValue: () => [...FEE_CHANNELS] })
  petFeeChannels!: string[];
  @attr('array', { defaultValue: () => [...FEE_CHANNELS] })
  linenFeeChannels!: string[];
  @attr('array', { defaultValue: () => [...FEE_CHANNELS] })
  resortFeeChannels!: string[];
  @attr('array', { defaultValue: () => [...FEE_CHANNELS] })
  communityFeeChannels!: string[];
  @attr('array', { defaultValue: () => [...FEE_CHANNELS] })
  managementFeeChannels!: string[];

  @belongsTo('property', {
    inverse: 'propertyFee',
    async: false,
  })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'property-fee': PropertyFeeModel;
  }
}
